import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";
import { GiftCardType } from "../types";
import { GlobalState } from "../../store";
import { giftCardUIDs } from "@/global/config/constants";

export interface CreateGiftCard {
  sendNow: boolean;
  recipientDetails?: { email: string; message?: string };
}
interface GiftCardsInitialState {
  giftCards: GiftCardType[];
  selectGiftCardsId: number;
  selectGiftCardsAmount: string;
  createGiftCard: CreateGiftCard;
  isGiftCardLoading: boolean;
}

const initialState: GiftCardsInitialState = {
  giftCards: [],
  selectGiftCardsAmount: "0",
  selectGiftCardsId: 0,
  createGiftCard: {} as CreateGiftCard,
  isGiftCardLoading: false,
};

export const purchaseGiftCards = createSlice({
  name: "purchaseGiftCards",
  initialState,
  reducers: {
    setGiftCards: (state, action: PayloadAction<GiftCardType[]>) => {
      state.giftCards = action.payload;
    },
    setSelectedGiftCardsId: (state, action: PayloadAction<number>) => {
      state.selectGiftCardsId = action.payload;
    },
    removeSelectedGiftCardsId: (state) => {
      state.selectGiftCardsId = 0;
    },
    setSelectedGiftCardsAmount: (state, action: PayloadAction<string>) => {
      state.selectGiftCardsAmount = action.payload;
    },
    removeSelectedGiftCardsAmount: (state) => {
      state.selectGiftCardsAmount = "0";
    },
    setGiftCardLoading: (state, action: PayloadAction<boolean>) => {
      state.isGiftCardLoading = action.payload;
    },
    setCreateGiftCard: (state, action: PayloadAction<CreateGiftCard>) => {
      state.createGiftCard = action.payload;
    },
  },
});

const selector = (s: GlobalState) => s.data.giftCards.purchaseGiftCards;

export const selectGiftCards = createSelector(selector, (s) => s.giftCards);
export const selectSelectedGiftCardsId = createSelector(
  selector,
  (s) => s.selectGiftCardsId
);
export const selectSelectedGiftCardsAmount = createSelector(
  selector,
  (s) => s.selectGiftCardsAmount
);
export const selectGiftCardIsLoading = createSelector(
  selector,
  (s) => s.isGiftCardLoading
);
export const selectCreateGiftCard = createSelector(
  selector,
  (s) => s.createGiftCard
);

export const {
  setGiftCards,
  setCreateGiftCard,
  removeSelectedGiftCardsId,
  setSelectedGiftCardsId,
  removeSelectedGiftCardsAmount,
  setSelectedGiftCardsAmount,
  setGiftCardLoading,
} = purchaseGiftCards.actions;

export default purchaseGiftCards.reducer;
